import { IDogSymbolsHandlerOptions, ISymbolsHandler } from '../../getSymbolsChecks.types';
import { handlerEmail } from './handlerEmail/handlerEmail';
import { handlerMention } from './handlerMention/handlerMention';

export const handlerDog =
  ({ userMentions }: IDogSymbolsHandlerOptions): ISymbolsHandler =>
  (opts) => {
    handlerEmail(opts);
    handlerMention(userMentions)(opts);
  };
